<template>
        <div v-if="show" class="modal-overlay" @click.self="closeModal">
                <div class="modal-content">
                        <div class="modal-header">
                        <h2>{{ $t('legacy.Создать новый проект') }}</h2>
                        <button class="close-button" @click="closeModal" :aria-label="$t('legacy.Закрыть окно')">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M18 6L6 18" stroke="#7A8A99" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M6 6L18 18" stroke="#7A8A99" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                </button>
                        </div>

                        <div class="modal-body">
                                <div class="form-group">
                                        <label for="zoneTitle">{{ $t('legacy.Название проекта') }}</label>
                                        <input type="text" id="zoneTitle" v-model="newZoneTitle" @input="validateInput"
                                                :placeholder="$t('Введите название (макс. 68 символов)')" maxlength="68" class="form-input"
                                                @keyup.enter="createZone">
                                        <div class="char-counter">{{ newZoneTitle.length }}/68</div>
                                        <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>
                                </div>
                        </div>

                        <div class="modal-actions">
                                <button class="cancel-btn" @click="closeModal">{{ $t('common.cancel') }}</button>
                                <button class="create-btn" @click="createZone"
                                        :disabled="!newZoneTitle.trim() || newZoneTitle.length > 68 || Boolean(errorMessage)">
                                        {{ $t('common.create') }}
                                </button>
                        </div>
                </div>
        </div>
</template>

<script>
export default {
        props: {
                show: Boolean,
                hasZones: {
                        type: Boolean,
                        default: false
                },
                existingTitles: {
                        type: Array,
                        default: () => []
                }
        },
        data() {
                return {
                        newZoneTitle: '',
                        errorMessage: '',
                }
        },
        methods: {
                closeModal() {
                        this.$emit('close')
                        this.newZoneTitle = ''
                },
                createZone() {
                        const trimmedTitle = this.newZoneTitle.trim()
                        if (!trimmedTitle || trimmedTitle.length > 68) return

                        // Финальная проверка
                        const duplicate = this.existingTitles.some(
                                title => title.toLowerCase() === trimmedTitle.toLowerCase()
                        )

                        if (duplicate) {
                                this.errorMessage = this.$t('legacy.Название уже используется')
                                return
                        }

                        this.$emit('create', trimmedTitle)
                        this.newZoneTitle = ''
                        this.errorMessage = ''
                },
                validateInput() {
                        // Ограничиваем по длине
                        if (this.newZoneTitle.length > 68) {
                                this.newZoneTitle = this.newZoneTitle.substring(0, 68)
                        }

                        const trimmed = this.newZoneTitle.trim()

                        if (trimmed.length === 0) {
                                this.errorMessage = ''
                                return
                        }

                        // Проверка на дубликат без учета регистра
                        const isDuplicate = this.existingTitles.some(
                                title => title.toLowerCase() === trimmed.toLowerCase()
                        )

                        if (isDuplicate) {
                                this.errorMessage = this.$t('legacy.Название уже используется')
                        } else {
                                this.errorMessage = ''
                        }
                }
        },
        watch: {
                existingTitles: {
                        handler() {
                                this.validateInput()
                        },
                        deep: true
                }
        },
}
</script>

<style scoped>
.modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.6);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 10000;
        backdrop-filter: blur(4px);
        animation: fadeIn 0.3s ease;
}

.modal-content {
        background: #ffffff;
        border-radius: 16px;
        width: 100%;
        max-width: 480px;
        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
        overflow: hidden;
        animation: slideDown 0.25s ease-out;
}

.modal-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 24px 28px;
        background-color: #f9fafb;
        border-bottom: 1px solid #e5e7eb;
}

.modal-header h2 {
        margin: 0;
        color: #1f2937;
        font-size: 20px;
        font-weight: 600;
}

.close-button {
        top: 16px;
        right: 16px;
        background: none;
        border: none;
        padding: 0;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: transform 0.2s ease;
}

.close-button:hover {
        transform: rotate(90deg);
}

.modal-body {
        padding: 28px;
        background-color: #ffffff;
}

.form-group label {
        display: block;
        margin-bottom: 10px;
        font-size: 14px;
        color: #374151;
        font-weight: 500;
}

.form-input {
        width: 100%;
        padding: 12px 16px;
        border: 1px solid #d1d5db;
        border-radius: 10px;
        font-size: 15px;
        transition: 0.2s ease;
        box-sizing: border-box;
        background-color: #f9fafb;
}

.form-input:focus {
        border-color: #3b82f6;
        background-color: #fff;
        outline: none;
        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
}

.char-counter {
        text-align: right;
        font-size: 12px;
        color: #6b7280;
        margin-top: 6px;
}

.error-message {
        color: #ef4444;
        font-size: 13px;
        margin-top: 6px;
}

.modal-actions {
        display: flex;
        justify-content: flex-end;
        gap: 12px;
        padding: 20px 28px;
        background-color: #f9fafb;
        border-top: 1px solid #e5e7eb;
}

.cancel-btn,
.create-btn,
.delete-all-btn {
        padding: 10px 18px;
        border-radius: 8px;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
        transition: background 0.2s;
}

.cancel-btn {
        background-color: #e5e7eb;
        color: #374151;
        border: none;
}

.cancel-btn:hover {
        background-color: #d1d5db;
}

.create-btn {
        background-color: #3b82f6;
        color: #fff;
        border: none;
}

.create-btn:disabled {
        background-color: #93c5fd;
        cursor: not-allowed;
}

.create-btn:not(:disabled):hover {
        background-color: #2563eb;
}

.delete-all-btn {
        background-color: #ef4444;
        color: #fff;
        border: none;
        margin-right: auto;
}

.delete-all-btn:hover {
        background-color: #dc2626;
}

.confirm-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.6);
        backdrop-filter: blur(3px);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1001;
}

.confirm-dialog {
        background: #fff;
        padding: 28px;
        border-radius: 16px;
        width: 100%;
        max-width: 400px;
        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25);
}

.confirm-dialog h3 {
        margin: 0 0 12px;
        color: #1f2937;
        font-size: 18px;
        font-weight: 600;
}

.confirm-dialog p {
        margin-bottom: 24px;
        color: #4b5563;
        font-size: 14px;
}

.confirm-actions {
        display: flex;
        justify-content: flex-end;
        gap: 10px;
}

.confirm-actions button {
        padding: 8px 16px;
        border-radius: 8px;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
        transition: 0.2s ease;
        border: none;
}

.confirm-actions button:first-child {
        background-color: #e5e7eb;
        color: #374151;
}

.confirm-actions button:first-child:hover {
        background-color: #d1d5db;
}

.confirm-delete {
        background-color: #ef4444;
        color: white;
}

.confirm-delete:hover {
        background-color: #dc2626;
}

@keyframes fadeIn {
        from {
                opacity: 0;
        }

        to {
                opacity: 1;
        }
}

@keyframes slideDown {
        from {
                transform: translateY(-20px);
                opacity: 0;
        }

        to {
                transform: translateY(0);
                opacity: 1;
        }
}
</style>